import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { UnSubscriber } from "../UnSubscriber";
import { ToastrService } from "ngx-toastr";
import { Store } from "@ngrx/store";
import { MobiOfficeUIState } from "../state-management/mobi-office-ui.interface";
import { UserManagementService } from "../services/user-management.service";
import { ENVIRONMENT } from "../environments/environments.token";
import { Environment } from "../environments/environment.interface";
import { GET_MOBIOFFICE_UI_User_SUCCESS } from "../state-management/mobi-office-ui.action";
import { Cls_ChangeUserPassword, Cls_GetOTPMaster, Cls_MBUser, Cls_UserLogin, Cls_VerifyOTPMaster } from "../models";
import { MagicBellService } from "../services";
import { Observable } from "rxjs";
import { select_MOUI_ApplicationDetails } from "../state-management/mobi-office-ui.selector";

enum ACTION_TYPE {
  LOGIN = "LOGIN",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  VERIFY_OTP = "VERIFY_OTP",
  RESET_PASSWORD = "RESET_PASSWORD",
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

@Component({
  selector: "mobi-office-lib-log-in-page",
  templateUrl: "./log-in-page.component.html",
  styleUrls: ["./log-in-page.component.scss"],
  standalone: false,
})
export class LogInPageComponent extends UnSubscriber implements OnInit {
  private readonly toastr = inject(ToastrService);
  private readonly store = inject<Store<MobiOfficeUIState>>(Store);
  private readonly userManagementService = inject(UserManagementService);
  private readonly magicBellService = inject(MagicBellService);
  private env: Environment = inject(ENVIRONMENT);

  constructor() {
    super();
  }

  ngOnInit(): void {
    setTimeout(() => {
      const token = localStorage.getItem("token");
      if (token) this.onSignIn(token);
    }, 1000);
  }

  @Input() isBannerLogoVisible: boolean = true;
  @Input() isCardLogoVisible: boolean = false;
  @Input() isForgetPassword: boolean = false;

  @Output() signInEmitter = new EventEmitter();
  @Output() signInInfoEmitter = new EventEmitter();

  UserName: string = "";
  Password: string = "";
  readonly ACTION_TYPE = ACTION_TYPE;
  selectedActionType = ACTION_TYPE.LOGIN;
  emailID: string = "";
  private OTP_ID: number = 0;
  OTP: string = "";
  private intervalHandler: any;
  timeInterval: number = 0;
  password: string = "";
  confirmPassword: string = "";

  get applicationInfo$(): Observable<any> {
    return this.store.select(select_MOUI_ApplicationDetails);
  }

  private validateForm(): boolean {
    let isValid: boolean = true;
    let msg: string = "";

    if (!this.UserName?.trim()) {
      msg += "Username is required.\n";
    }

    if (!this.Password?.trim()) {
      msg += "Password is required.\n";
    }

    if (msg) {
      this.toastr.info(msg, "Info");
      isValid = false;
    }

    return isValid;
  }

  onSignIn(token: string = "") {
    if (!token) if (!this.validateForm()) return;
    const tempModal = new Cls_UserLogin();
    tempModal.appName = this.env.APP_NAME || "";
    tempModal.companyName = this.env.COMPANY_NAME || "";
    tempModal.username = this.UserName;
    tempModal.password = this.Password;
    tempModal.token = token;
    console.log(tempModal);
    localStorage.removeItem("token");
    this.anotherSubscription = this.userManagementService.UserLogIn(tempModal).subscribe(async (res: any) => {
      if (this.env.MAGIC_BELL_KEY && this.env.MAGIC_BELL_SECRET_KEY && this.env.MAGIC_BELL_API) {
        const { UserInfo } = res;
        const tempUserModal = new Cls_MBUser();
        tempUserModal.user.id = UserInfo.MagicBellID;
        tempUserModal.user.external_id = UserInfo.UID + "";
        tempUserModal.user.email = UserInfo.EmailID;
        tempUserModal.user.first_name = UserInfo.Name;
        tempUserModal.user.phone_numbers = [UserInfo.Phone];

        try {
          const checkUserIsExist: any = await this.magicBellService.getUserByID(UserInfo.MagicBellID).toPromise();
          const USER = checkUserIsExist.user;
          const isValidInfo = USER.email?.trim() === UserInfo?.EmailID && USER.Name?.trim() === UserInfo?.first_name?.trim() && !!USER?.phone_numbers?.find((el: string) => el === UserInfo?.Phone);

          // Update User if information is not matched
          if (!isValidInfo) {
            try {
              await this.magicBellService.updateUser(tempUserModal).toPromise();
            } catch (error) {
              console.error(error);
            }
          }
        } catch (error: any) {
          const { status } = error;

          // Create User in Magic Bell
          if (status === 400) {
            try {
              delete tempUserModal.user.id;
              const userInsert: any = await this.magicBellService.createUser(tempUserModal).toPromise();
              const { user } = userInsert;
              await this.userManagementService.UpdateUserID(user.id, UserInfo.UID).toPromise();
              res.UserInfo.MagicBellID = user.id;
            } catch (error) {
              console.error(error);
            }
          }
        }
      }

      this.store.dispatch(
        GET_MOBIOFFICE_UI_User_SUCCESS({
          payload: {
            UserInfo: res,
          },
        })
      );

      this.signInEmitter.emit(res);
      this.signInInfoEmitter.emit(tempModal);
    });
  }

  get getCardTitle(): string {
    switch (this.selectedActionType) {
      case ACTION_TYPE.LOGIN:
        return "Login";
      case ACTION_TYPE.FORGOT_PASSWORD:
        return "Forgot Password";
      case ACTION_TYPE.VERIFY_OTP:
        return "Verify OTP";
      case ACTION_TYPE.RESET_PASSWORD:
        return "Reset Password";
      default:
        return "";
    }
  }

  //#region FORGOT PASSWORD

  onLoginPage() {
    switch (this.selectedActionType) {
      case ACTION_TYPE.FORGOT_PASSWORD:
      case ACTION_TYPE.RESET_PASSWORD:
        this.forgotPassword();
        this.selectedActionType = ACTION_TYPE.LOGIN;
        break;
      case ACTION_TYPE.VERIFY_OTP:
        this.selectedActionType = ACTION_TYPE.FORGOT_PASSWORD;
        break;
      default:
    }
  }

  private startInterval() {
    if (this.intervalHandler) clearInterval(this.intervalHandler);
    this.intervalHandler = setInterval(() => {
      this.timeInterval--;
      if (this.timeInterval <= 0) {
        clearInterval(this.intervalHandler);
      }
    }, 1000);
  }

  forgotPassword() {
    this.selectedActionType = ACTION_TYPE.FORGOT_PASSWORD;
    this.emailID = "";
    this.OTP_ID = 0;
    this.OTP = "";
  }

  sentOTP() {
    if (this.timeInterval > 0) return;
    const tempModal = new Cls_GetOTPMaster();
    tempModal.emailID = this.emailID?.trim();
    tempModal.applicationName = this.env.APP_NAME;
    tempModal.companyName = this.env.COMPANY_NAME;
    this.anotherSubscription = this.userManagementService.GetOTP(tempModal).subscribe((res: any) => {
      this.OTP_ID = res.OTP_ID;
      this.timeInterval = 60;
      this.toastr.success("OTP Sent", "Success");
      this.selectedActionType = ACTION_TYPE.VERIFY_OTP;
      this.startInterval();
    });
  }

  onContinue() {
    this.emailID = this.emailID.trim();
    if (!this.emailID?.trim()) {
      this.toastr.info("Email is required.", "Info");
      return;
    }

    if (!emailRegex.test(this.emailID.trim())) {
      this.toastr.info("Please enter valid email.", "Info");
      return;
    }

    this.OTP_ID = 0;
    this.OTP = "";
    this.sentOTP();
  }

  private verifyOTPCode() {
    if (!this.OTP) {
      this.toastr.info("OTP is required.", "Info");
      return;
    }
    const tempModal = new Cls_VerifyOTPMaster();
    tempModal.OTP_ID = this.OTP_ID;
    tempModal.OTP_CODE = this.OTP;
    this.anotherSubscription = this.userManagementService.VerifyOTP(tempModal).subscribe((res: any) => {
      this.selectedActionType = ACTION_TYPE.RESET_PASSWORD;
      this.toastr.success(res.message, "Success");
    });
  }

  onVerifyOtp() {
    this.verifyOTPCode();
    this.password = "";
    this.confirmPassword = "";
  }

  private validateResetPassword() {
    if (!this.password) {
      this.toastr.info("Password is required", "Info");
      return false;
    }

    if (this.password.length < 6) {
      this.toastr.info("Password must be at least 6 characters long", "Info");
      return false;
    }

    if (this.password && !this.confirmPassword) {
      this.toastr.info("Confirm Password is required", "Info");
      return false;
    }

    if (this.password && this.confirmPassword && this.password !== this.confirmPassword) {
      this.toastr.info("Password and confirm password do not match", "Info");
      return false;
    }

    return true;
  }

  onResetPassword() {
    if (!this.validateResetPassword()) return;
    const tempModal = new Cls_ChangeUserPassword();
    tempModal.applicationName = this.env.APP_NAME;
    tempModal.companyName = this.env.COMPANY_NAME;
    tempModal.NewPassword = this.confirmPassword;
    tempModal.EmailID = this.emailID?.trim();
    tempModal.OTP_CODE = this.OTP;
    tempModal.OTP_ID = this.OTP_ID;
    this.anotherSubscription = this.userManagementService.UpdateUserPasswordUsingOTP(tempModal).subscribe((res: any) => {
      this.toastr.success(res.message, "Success");
      this.selectedActionType = ACTION_TYPE.LOGIN;
    });
  }

  //#endregion
}
